// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sliderPhoto {\n  border-radius: 12px;\n}", "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/customer/homeactivitylombok.scss"],"names":[],"mappings":"AAAA;EAAa,mBAAA;AAEb","sourcesContent":[".sliderPhoto{border-radius: 12px;}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
